import React from "react";

import { Center, chakra } from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { APIOption } from "@noli/core";

import { genBlock } from "@/utils/bem";
import { Editor_Words } from "@/utils/lang/editor";
import SchemaProperty from "@/components/Property/SchemaProperty";
import { observer } from "mobx-react-lite";
import classNames from "classnames";

interface CircularSwitchProps {
  alias: string;
  circular: boolean;
  onChange: (circular: boolean) => void;
  className?: string;
}

const block = genBlock("c-circular-switch");

const ICircularSwitch: React.FC<CircularSwitchProps> = ({
  alias,
  circular,
  onChange,
  className,
}) => {
  const lang = langStore.tgt;
  return (
    <Center className={classNames(block(), className)} mt="16px">
      <SchemaProperty
        identifier={`${alias}-circular`}
        w="100%"
        py="4px"
        pr="4px"
        color="#E5E5E5"
        lang={lang}
        apiKey={Editor_Words["txt2img-sd-circular"]}
        apiOption={new APIOption("bool", circular)}
        value={circular}
        setValue={() => onChange}
        fontSize="14px"
      />
    </Center>
  );
};

export const CircularSwitch = chakra(observer(ICircularSwitch));
